import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "questions-default",
  class: "flex flex-col gap-5"
}
const _hoisted_2 = { id: "items" }
const _hoisted_3 = { class: "flex flex-row items-center gap-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-lg col-span-12 my-5" }, "Itens", -1)
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-red-500"
}
const _hoisted_6 = { class: "p-5 bg-white rounded-md shadow-sm border col-span-10 mb-5" }
const _hoisted_7 = {
  id: "enunciated-item",
  class: "mb-5"
}
const _hoisted_8 = {
  key: 0,
  id: "explanation-item"
}
const _hoisted_9 = {
  id: "item-action",
  class: "col-span-2 flex flex-col justify-center items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.store.selectCorrect)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.t("labels.generic", {
              pt: "Você deve indicar qual o item correto",
              en: "You must indicate which item is correct",
            })), 1))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.form.items, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          id: "item-question",
          class: "grid grid-cols-12 gap-3",
          key: i
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Textarea, {
                id: "question-input",
                autoResize: true,
                rows: "3",
                cols: "30",
                placeholder: _ctx.t('question.prompt.items.empty'),
                modelValue: item.answerText,
                "onUpdate:modelValue": ($event: any) => ((item.answerText) = $event),
                class: _normalizeClass(
                _ctx.store.v$.form.items.$each.$response.$errors[i].answerText
                  ?.length !== 0 && _ctx.store.v$.form.$error
                  ? 'p-invalid'
                  : ''
              ),
                maxlength: 999
              }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "class"]),
              _createVNode(_component_Errors, {
                errors: 
                _ctx.store.v$.form.items.$each.$response.$errors[i].answerText
              ,
                actualLength: item.answerText?.length,
                maxLength: 999
              }, {
                msg: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.store.v$.form.$error ? _ctx.t("validations.required") : ""), 1)
                ]),
                _: 2
              }, 1032, ["errors", "actualLength"])
            ]),
            (_ctx.store.getIsAdaptive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_Textarea, {
                    id: "description-input",
                    autoResize: true,
                    rows: "5",
                    cols: "30",
                    placeholder: _ctx.t('question.prompt.items.description.empty'),
                    modelValue: item.answerDescription,
                    "onUpdate:modelValue": ($event: any) => ((item.answerDescription) = $event),
                    class: _normalizeClass(
                _ctx.store.v$.form.items.$each.$response.$errors[i].answerDescription
                  ?.length !== 0 && _ctx.store.v$.form.$error
                  ? 'p-invalid'
                  : ''
              ),
                    maxlength: 999
                  }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "class"]),
                  _createVNode(_component_Errors, {
                    errors: 
                _ctx.store.v$.form.items.$each.$response.$errors[i].answerDescription
              ,
                    actualLength: item.answerDescription?.length,
                    maxLength: 999
                  }, {
                    msg: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.store.v$.form.$error ? _ctx.t("validations.required") : ""), 1)
                    ]),
                    _: 2
                  }, 1032, ["errors", "actualLength"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_v_icon, {
              name: "hi-solid-check-circle",
              class: _normalizeClass(`${
              item.id === _ctx.store.form.correctItem?.id || item.correct
                ? 'text-green-500'
                : 'text-gray-400'
            } cursor-pointer hover:scale-95 transition-all ${
              _ctx.store.v$.form.items.$each.$response.$errors[i].correct?.length !==
                0 && _ctx.store.v$.form.$error
                ? 'border-2 border-red-500 rounded-full'
                : ''
            }`),
              scale: item.id === _ctx.store.form.correctItem?.id ? 4 : 3,
              onClick: ($event: any) => (_ctx.chooseCorrectItem(item, _ctx.store.form.items))
            }, null, 8, ["class", "scale", "onClick"])
          ])
        ]))
      }), 128))
    ])
  ]))
}